import { DownOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import {
  Channel,
  ErrorResponse,
  GET_CHANNEL_BY_ID,
  GET_CHANNEL_IDEA,
  Idea,
  PATCH_IDEA_PHASE,
} from '@frontend/data-access';
import { App, Button, Dropdown } from 'antd';
import useTranslation from 'next-translate/useTranslation'; // Added translation import
import { useState } from 'react';

function PhaseActionButton({ idea }: { idea: Idea }) {
  const { notification } = App.useApp();
  const { t } = useTranslation('common');
  const [destinationId, setDestinationId] = useState<string>();
  const { data, loading } = useQuery<{
    channel: Channel;
  }>(GET_CHANNEL_BY_ID, {
    variables: {
      id: idea.channel.id,
    },
  });

  const handleStageChangeCompleted = (data: { patchIdeaPhase: string }) => {
    if (data?.patchIdeaPhase) {
      notification.success({
        message: t('phase_update_success'),
      });
    }
  };

  const handleStageChangeError = (error: ErrorResponse) => {
    notification.error({
      message: t('phase_update_error'),
      description: error.message,
    });
  };

  const [phaseChange, { loading: patchLoading }] = useMutation(
    PATCH_IDEA_PHASE,
    {
      onCompleted: handleStageChangeCompleted,
      onError: handleStageChangeError,
      refetchQueries: [
        { query: GET_CHANNEL_IDEA, variables: { ideaId: idea.id } },
        {
          query: GET_CHANNEL_BY_ID,
          variables: { id: idea.channel.id },
          fetchPolicy: 'network-only',
        },
      ],
    }
  );

  const handleChange = async (destinationId: string) => {
    await setDestinationId(destinationId);
    await phaseChange({
      variables: {
        ideaId: idea.id,
        phaseId: destinationId,
        channelId: idea.channel.id,
      },
    });
  };

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: data?.channel.channelPhases.map((item) => ({
          key: item.phase.id,
          label: item.phase.title,
          onClick: () => handleChange(item.phase.id),
          disabled: idea.currentPhase.phase.id === item.phase.id,
        })),
      }}
    >
      <Button
        className="flex flex-row-reverse items-center"
        shape="round"
        loading={loading || patchLoading}
        icon={<DownOutlined />}
      >
        <span className="max-w-36 truncate">
          {idea.currentPhase.phase.title}
        </span>
      </Button>
    </Dropdown>
  );
}

export default PhaseActionButton;
